import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITag, ITagResource } from "../types";

export interface ITagQueryParameters {
    tag?: RelationalValue<ITagResource>;
    locale?: string;
}

export type ITagQueryResult = ITag;

export const tagQuery: IApiQueryFunction<ITagQueryParameters> = ({ tag, locale }) => {
    if (!tag) {
        return;
    }

    return {
        method: "GET",
        url: `/tags/${mapRelationalValue(tag)}`,
        ...(locale ? { headers: { "x-locale": locale } } : {}),
    };
};

export const useTagQuery = createApiQueryHook<ITagQueryParameters, ITagQueryResult>(tagQuery);
